import { Button, ButtonGroup, H6, Icon } from "@alternative/components";
import { Popover } from "@blueprintjs/core";
import React, { useRef, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { advancedModeState, apiKeyState, designListState } from "../../recoil/filemanager/atoms";
import { v4 } from "uuid";
import { addNewNode } from "../../utils";
import { FileManagerAPI } from "../../api";
import { IconNames } from "@alternative/icons";
import UploadButton from "./UploadButton";
const FOLDER_POPUP = "new-folder-popup";
const FOLDER_POPUP_TITLE = `${FOLDER_POPUP}__title`;
const FOLDER_POPUP_INPUT = `${FOLDER_POPUP}__input`;
const FOLDER_POPUP_BUTTONS = `${FOLDER_POPUP}__buttons`;

const Toolbar = () => {
  const [designList, setDesignList] = useRecoilState(designListState);
  const [advancedMode, setAdvancedMode] = useRecoilState(advancedModeState);
  const { designTree, selectedFolders } = designList;
  const [newFolderName, setNewFolderName] = useState("New Folder");

  const apiKey = useRecoilValue(apiKeyState);
  const folderNameRef = useRef();
  const handleAddFolder = async (e) => {
    e.preventDefault();

    let location, fullPath, level;
    let name = newFolderName;
    let isExpanded = false;
    let children = [];
    let files = [];
    let type = "folder";
    let id = v4();
    if (selectedFolders.length === 1) {
      location = selectedFolders[0].fullPath;
      level = selectedFolders[0].level + 1;
    } else {
      location = selectedFolders[0].location;
      level = selectedFolders[0].level;
    }
    fullPath = `${location}/${newFolderName}`;
    const add = await FileManagerAPI.addFolder({ key: apiKey, path: fullPath });
    if (!add) return;
    const newNode = { id, type, name, fullPath, location, level, children, files, isExpanded };
    const { updatedTree } = addNewNode(designTree, newNode);

    setDesignList({ ...designList, designTree: updatedTree, selectedFolders: [newNode] });
  };
  const newFolderPopup = (
    <div className={FOLDER_POPUP}>
      <H6 className={FOLDER_POPUP_TITLE}>Give a name to your new folder</H6>
      <form onSubmit={handleAddFolder}>
        <input
          // autoFocus
          onFocus={(e) => e.target.select()}
          ref={folderNameRef}
          className={FOLDER_POPUP_INPUT}
          value={newFolderName}
          onChange={(e) => setNewFolderName(e.target.value)}
        />
      </form>
      <div className={FOLDER_POPUP_BUTTONS}>
        <Button text="Add" onClick={handleAddFolder} intent="primary" />
        <Button text="Cancel" />
      </div>
    </div>
  );
  return (
    <div className="fm-toolbar">
      <div className="fm-toolbar__tools">
        <Popover content={newFolderPopup} interactionKind="hover">
          <Button minimal>
            <Icon icon={IconNames.NEW_FOLDER} />
            <H6>New Folder</H6>
          </Button>
        </Popover>
        <UploadButton />
      </div>
      <ButtonGroup>
        <Button text="Advanced" intent={advancedMode ? "primary" : null} onClick={() => setAdvancedMode(true)} />
        <Button text="Simple" intent={!advancedMode ? "primary" : null} onClick={() => setAdvancedMode(false)} />
      </ButtonGroup>
    </div>
  );
};

export default Toolbar;
